import { Avatar } from '@material-ui/core';
import React from 'react';
import { useTheme } from '../constants/themeProvider';

function CUserImageIcon(props) {
    const { src } = props;
    const theme = useTheme();
    let imageUrl = src || '';
    return (
        <Avatar src={imageUrl} style={{ backgroundColor: !imageUrl ? theme?.primaryColor : null }} className="my-image"/>
    );
}

export default CUserImageIcon;
